module.exports = __webpack_public_path__ + "img/mur_marque-places.png";